
// @ts-nocheck
import locale__app_template1_locales_en_json from "../locales/en.json";
import locale__app_template1_locales_ar_json from "../locales/ar.json";
import locale__app_template1_locales_fr_json from "../locales/fr.json";


export const localeCodes =  [
  "en",
  "ar",
  "fr"
]

export const localeLoaders = {
  "en": [{ key: "../locales/en.json", load: () => Promise.resolve(locale__app_template1_locales_en_json), cache: true }],
  "ar": [{ key: "../locales/ar.json", load: () => Promise.resolve(locale__app_template1_locales_ar_json), cache: true }],
  "fr": [{ key: "../locales/fr.json", load: () => Promise.resolve(locale__app_template1_locales_fr_json), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "iso": "en-US",
      "name": "English",
      "dir": "ltr",
      "files": [
        "locales/en.json"
      ]
    },
    {
      "code": "ar",
      "iso": "ar-SA",
      "name": "Arabic",
      "dir": "rtl",
      "files": [
        "locales/ar.json"
      ]
    },
    {
      "code": "fr",
      "iso": "fr-FR",
      "name": "France",
      "dir": "ltr",
      "files": [
        "locales/fr.json"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": "locales",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "iso": "en-US",
    "name": "English",
    "dir": "ltr",
    "files": [
      {
        "path": "locales/en.json"
      }
    ]
  },
  {
    "code": "ar",
    "iso": "ar-SA",
    "name": "Arabic",
    "dir": "rtl",
    "files": [
      {
        "path": "locales/ar.json"
      }
    ]
  },
  {
    "code": "fr",
    "iso": "fr-FR",
    "name": "France",
    "dir": "ltr",
    "files": [
      {
        "path": "locales/fr.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
